var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Inputmask from "inputmask";
import axios from "axios";
var windowId = '#updatePhoneDialog';
var closeId = '#updatePhoneDialogClose';
var updatePhoneDialogOkContent = '#updatePhoneDialogOkContent';
var okBtnId = '#updatePhoneDialogOk';
var promtInputId = '#updatePhoneDialogInput';
var timerDurationDefaultT = 120;
var codeOkBtnId = '#codeUpdatePhoneDialogOk';
var codeInputId = '#codeUpdatePhoneDialogInput';
var codeContentId = '#codeContent';
var resendCodeBtnId = '#resendCodeBtn';
$(document).ready(function () {
    var phone = new Inputmask("+7 (999) 999-99-99");
    phone.mask(promtInputId);
    var code = new Inputmask("9999");
    code.mask(codeInputId);
});
export function showInputPhone(value) {
    // $('#promtTitle').text(title || 'Введите');
    return new Promise(function (resolve, reject) {
        $(windowId).addClass('modal-open');
        var $input = $(promtInputId);
        if (value)
            $input.val(value);
        $input.focus();
        $(promtInputId).on("input", function () {
            clearError();
        });
        $(okBtnId).on('click', function () {
            var promt = $(promtInputId).val();
            setDisabledInputPhone(true);
            resolve(promt);
        });
        $(closeId).on('click', function () {
            clear();
            $(promtInputId).val('');
            toggleTimer(false);
            clearIntervals();
            reject();
        });
        $input.on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                var promt = $(promtInputId).val();
                resolve(promt);
                clear();
            }
        });
    })
        .finally(function () {
        clear();
    });
}
export function showInputCode() {
    return new Promise(function (resolve, reject) {
        setDisplayCodeInput(true);
        var $input = $(codeInputId);
        $input.focus();
        $(codeInputId).on("input", function () {
            clearError();
        });
        $(codeOkBtnId).on('click', function () {
            var promt = $(codeInputId).val();
            resolve(promt);
        });
        $(closeId).on('click', function () {
            clear();
            $(promtInputId).val('');
            toggleTimer(false);
            clearIntervals();
            reject();
        });
        $input.on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                setDisabledInputPhone(true);
                var promt = $(codeInputId).val();
                resolve(promt);
                clear();
            }
        });
    })
        .finally(function () {
        clear();
        $(okBtnId).off('click');
        $(closeId).off('click');
    });
}
export function close() {
    clear();
    setDisplayCodeInput(false);
    $(windowId).removeClass('modal-open');
}
export function setError(message) {
    $(promtInputId).addClass('input-error');
    $('#inputGetCodeErrorText').html(message);
}
export function setErrorCheckCode(message) {
    $(codeInputId).addClass('input-error');
    $('#inputSendCodeErrorText').html(message);
}
export function clear() {
    $(promtInputId).removeClass('input-error');
    $('#inputGetCodeErrorText').empty();
    $('#inputSendCodeErrorText').empty();
    $(promtInputId).removeClass('input-error');
    $(codeInputId).removeClass('input-error');
    setDisabledInputPhone(false);
    $(codeInputId).val('');
    $(codeInputId).val('');
}
export function clearError() {
    $(promtInputId).removeClass('input-error');
    $(codeInputId).removeClass('input-error');
    $('#inputGetCodeErrorText').empty();
    $('#inputSendCodeErrorText').empty();
}
export function setDisabledInputPhone(isDisabled) {
    if (isDisabled) {
        $(promtInputId).prop('disabled', true);
    }
    else {
        $(promtInputId).prop('disabled', false);
    }
}
export function setDisabledInputPhoneBtn(isDisabled) {
    if (isDisabled) {
        $(okBtnId).prop('disabled', true);
    }
    else {
        $(okBtnId).prop('disabled', false);
    }
}
export function changePlaceTimer(isChange) {
    if (isChange) {
        var html = $("<div />").append($("#onlyTimerContent").clone()).html();
        $('#forTimerPlace').html(html);
    }
    else {
        $('#forTimerPlace').empty();
    }
}
export function setDisplayCodeInput(isDisplay) {
    if (isDisplay) {
        $(codeContentId).removeClass('hidden');
        $(updatePhoneDialogOkContent).addClass('hidden');
    }
    else {
        $(codeContentId).addClass('hidden');
        $(updatePhoneDialogOkContent).removeClass('hidden');
    }
}
export function startTimer(duration, isSetStart) {
    $('#timerMin')[0].style.setProperty("--value", '00');
    $('#timerSec')[0].style.setProperty("--value", '00');
    var timer = duration, minutes, seconds;
    toggleTimer(true);
    var date = rightNow();
    var sec = (new Date(date)).getTime() / 1000;
    var previousDate = getItemLocalStorage();
    if (previousDate && !isSetStart) {
        var time = sec - previousDate;
        if (time > 0) {
            timer = timerDurationDefaultT - time;
        }
    }
    else {
        setItemLocalStorage(sec);
    }
    $('#timerContent').removeClass('hidden');
    var myTimer = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        $('#timerMin')[0].style.setProperty("--value", minutes);
        $('#timerSec')[0].style.setProperty("--value", seconds);
        if (--timer < 0) {
            timer = duration;
            toggleTimer(false);
            setDisabledInputPhone(false);
            clearInterval(myTimer);
            removeItemLocalStorage();
            setDisabledInputPhoneBtn(false);
            setDisabledInputPhoneBtn(false);
            $('#timerMin')[0].style.setProperty("--value", '00');
            $('#timerSec')[0].style.setProperty("--value", '00');
        }
    }, 1000);
}
export function toggleTimer(isSetTimer) {
    if (isSetTimer) {
        $('#resendCodeBtn').addClass('hidden');
        $('#onlyTimerContent').removeClass('hidden');
    }
    else {
        $('#resendCodeBtn').removeClass('hidden');
        $('#onlyTimerContent').addClass('hidden');
    }
}
function setTimer(isDisabled) {
    if (isDisabled) {
        $('timerContent').addClass('hidden');
    }
    else {
        $('timerContent').removeClass('hidden');
    }
}
function clearIntervals() {
    var interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);
    for (var i = 1; i < interval_id; i++) {
        window.clearInterval(i);
    }
}
function removeItemLocalStorage() {
    return localStorage.removeItem('clickSendCode');
}
export function sendCheckCode(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/info/check-code', data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function setItemLocalStorage(seconds) {
    localStorage.setItem('clickSendCode', seconds.toString());
}
export function getItemLocalStorage() {
    return localStorage.getItem('clickSendCode');
}
function rightNow() {
    var currentTime = Date.now();
    return currentTime;
}
